export default __webpack_public_path__ + "static/media/order-overview.04945d04.svg";